// Microsoft Clarity (project yah375fq95): click/scroll heatmaps + session
// recordings. Loaded async on all 4 SPA templates. Because the storefront is a
// hash-routed SPA, every route change is also pushed to Clarity as a "route"
// tag and a page event, so product pages, cart, checkout etc. can be filtered
// and compared individually instead of all collapsing into "/".
(function (c, l, a, r, i, t, y) {
  c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
  t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
  y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
})(window, document, "clarity", "script", "yah375fq95");

(function () {
  var last = "";
  function routeName() {
    var h = String(location.hash || "").replace(/^#\/?/, "").replace(/\/+$/, "");
    if (!h) return location.pathname === "/" ? "home" : location.pathname.replace(/^\//, "");
    var parts = h.split("/");
    // product/<handle>/<dose> -> "product/<handle>" (dose kept as its own tag)
    if ((parts[0] === "product" || parts[0] === "pen" || parts[0] === "spray") && parts[1]) {
      if (parts[2]) { try { window.clarity("set", "variant", decodeURIComponent(parts[2])); } catch (e) {} }
      return parts[0] + "/" + parts[1];
    }
    return parts[0] + (parts[1] ? "/" + parts[1] : "");
  }
  function tag() {
    var r = routeName(); if (r === last) return; last = r;
    try {
      window.clarity("set", "route", r);
      window.clarity("set", "section", r.split("/")[0]);
      window.clarity("event", "route_" + r.split("/")[0]);
    } catch (e) {}
  }
  tag();
  window.addEventListener("hashchange", tag);
})();
